module.exports = __webpack_public_path__ + "static/media/main idea.7bf2dc26.mp3";